import AppModal from '@/components/AppModal/AppModal';
import { ModalSize } from '@shopify/polaris/build/ts/src/components/Modal';

interface Props {
  open: boolean;
  onClose: () => void;
  imgSrc: string;
  size: ModalSize;
}

export const ViewDemoModal = ({ open, onClose, imgSrc, size }: Props) => {
  return (
    <AppModal open={open} title="Demo" onCancel={onClose} size={size} onSubmit={() => {}}>
      <img src={imgSrc} style={{ width: '100%', objectFit: 'cover' }} alt="" />
    </AppModal>
  );
};
